import { styled, th } from '@smooth-ui/core-sc';

const BgSecondary = styled.section`
  align-items: center;
  background-color: ${th('secondary')};
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  width: 100%;
`;

export default BgSecondary;
